import { Injectable, computed, signal } from '@angular/core';

/** La commessa aperta, per il percorso della testata e il titolo della finestra. */
@Injectable({ providedIn: 'root' })
export class ProjectStore {
  private readonly current = signal<{ readonly id: string; readonly name: string } | null>(null);

  readonly name = computed(() => this.current()?.name ?? null);

  set(project: { readonly id: string; readonly name: string } | null): void {
    this.current.set(project);
  }
}
